export default __webpack_public_path__ + "5aaf26a5b85e3a6d8ed2a2827ef48a11.svg";